<template>
  <modal
    name="welcome-modal"
    :maxWidth="320"
    :minHeight="290"
    :click-to-close="false"
    :adaptive="true"
  >
    <div class="welcome-modal">
      <figure class="welcome-modal__photo">
        <img
          v-if="sellerInfo.photo"
          :src="sellerInfo.photo"
          alt="Seller photo"
          @error="hasError = true"
        />
        <i v-else class="fas fa-user" />
      </figure>
      <h4 v-if="sellerInfo.fullName" class="welcome-modal__seller-name">
        {{ sellerInfo.fullName }}
      </h4>
      <p v-if="sellerInfo.rooftopName" class="welcome-modal__rooftop-name">
        {{ sellerInfo.rooftopName }}
      </p>
      <p class="welcome-modal__message">
        {{ userWelcomeMessage }}
      </p>
      <base-button class="welcome-modal__cta" @click="handleStart">
        Start <i class="fas fa-arrow-right"></i>
      </base-button>
    </div>
  </modal>
</template>

<script>
import BaseButton from '@/components/base-button';

export default {
  name: 'WelcomeModal',
  components: {
    BaseButton,
  },
  props: {
    sellerInfo: {
      type: Object,
      required: true,
    },
    welcomeMessage: {
      type: String,
      required: true,
    },
    userFirstname: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      hasError: false,
    };
  },
  computed: {
    userWelcomeMessage() {
      const userGreeting = this.userFirstname ? `Hi ${this.userFirstname.trim()}!` : 'Hi!';
      return `${userGreeting} ${this.welcomeMessage}`;
    },
  },
  methods: {
    handleStart() {
      this.$emit('userStarted');
      this.$modal.hide('welcome-modal');
    },
  },
};
</script>

<style lang="scss">
.vm--modal {
  box-shadow: none !important;
}

.welcome-modal {
  border-radius: 6px;
  text-align: center;
  padding: 25px 0 35px;

  &__photo {
    width: 40px;
    height: 40px;
    margin: 0 auto 8px;

    img {
      border-radius: 50%;
      width: 100%;
    }
  }

  &__seller-name,
  &__rooftop-name,
  &__message {
    font-size: 14px;
    letter-spacing: -0.12px;

    @media (min-width: 992px) {
      font-size: 15px;
    }
  }

  &__seller-name {
    color: #707070;
  }

  &__rooftop-name {
    color: #c9c9c9;
    margin-bottom: 15px;
  }

  &__message {
    color: #9b9b9b;
    font-weight: 300;
    max-width: 290px;
    margin: 0 auto 30px;
  }
}
</style>
